// Module
var code = `<style></style> <div id="cost"></div> `;
// Exports
export default code;